import { render, staticRenderFns } from "./BrandLogoTextboxCollege.vue?vue&type=template&id=5a13d6d0&"
import script from "./BrandLogoTextboxCollege.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxCollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports